<template>
  <el-dialog title="异常通知" :visible.sync="dialogVisible" width="800" custom-class="dialog-title-left">
    <el-table :data="data">
      <el-table-column label="单号" prop="id">
      </el-table-column>
      <el-table-column label="异常原因">
        订单中未找到异常原因相匹配的商品运输属性
      </el-table-column>
    </el-table>
  </el-dialog>
</template>
<script>
export default {
  name: 'abnormalDialog',
  data() {
    return {
      data: [],
      dialogVisible: false
    }
  },
  methods: {
    open(data) {
      this.data = data
      this.dialogVisible = true
    }
  }
}
</script>

<style lang="less">
.dialog-title-left {
  .el-dialog__header {
    .el-dialog__title {
      margin-left: 20px;
    }
  }
}
</style>